import immerize from '../immerize'

const initialState = {
  status: '',
  error: null,
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case 'CLEAR_STORE':
      state = initialState
      break
    case 'WEB_INITIALIZATION_PENDING':
      state.error = null
      state.status = 'WEB_INITIALIZATION_PENDING'
      break
    case 'WEB_INITIALIZATION_FULFILLED':
      state.error = null
      state.status = 'WEB_INITIALIZATION_FULFILLED'
      break
    case 'WEB_INITIALIZATION_REJECTED':
      state.error = action.payload.error
      state.status = 'WEB_INITIALIZATION_REJECTED'
      break
    default:
      return state
  }
  return state
}

export default immerize(reducer)
